import type { PostHog } from "posthog-js";
import type {
  Analytics,
  Company,
  SharedProperties,
  User,
} from "../core/Analytics";
import type { BaseEvent } from "../core/BaseEvent";

export class PosthogAnalytics<
  TEvent extends BaseEvent<object> = BaseEvent<object>,
> implements Analytics<TEvent>
{
  private readonly posthog: PostHog;
  private readonly userType: string;

  constructor(posthog: PostHog, { userType }: { userType: string }) {
    this.posthog = posthog;
    this.userType = userType;
  }

  async alias(oldId: string, newId: string) {
    this.posthog.alias(oldId, newId);
  }

  async identify({ id, ...userProps }: User) {
    return new Promise<void>((resolve) => {
      this.posthog.featureFlags.addFeatureFlagsHandler(() => resolve());
      this.posthog.identify(id, { userType: this.userType, ...userProps });
    });
  }

  page() {
    this.posthog.capture("$pageview");
  }

  track({ "detail-type": detailType, detail, id, version, resources }: TEvent) {
    this.posthog.capture(detailType, {
      eventVersion: version,
      id,
      resources,
      ...detail,
    });
  }

  register(sharedProperties: SharedProperties) {
    this.posthog.register(sharedProperties);
  }

  identifyCompany({ id, ...companyProps }: Company) {
    this.posthog.group("company", id, companyProps);
  }
}
